import {useBannersByPlacement} from "@/hooks/useBanners";

type Props = {
    placement: string;          // e.g. "NEWS_RIGHT_TOP"
    className?: string;
    label?: string;             // optional small label above the ad (e.g. "Advertensie")
};

export default function SidebarBanner({placement, className = "", label = "Advertensie"}: Props) {
    const {data, isLoading, isError} = useBannersByPlacement(placement);

    if (isLoading) {
        return (
            <div className={`rounded-xl bg-gray-100 animate-pulse h-[600px] ${className}`}
                 aria-label={`${label} laai…`}/>
        );
    }

    if (isError || !data) {
        return null;
    }

    const img = data.imageUrl;
    const href = data.targetUrl ?? undefined;

    const image = (
        <img
            src={img}
            alt={data.title}
            className="w-full h-auto rounded-lg ring-1 ring-gray-200 object-cover"
            loading="lazy"
            decoding="async"
        />
    );

    return (
        <aside className={className}>
            {label && <p className="mb-2 text-xs uppercase tracking-wide text-gray-400">{label}</p>}
            {href ? (
                <a href={href}
                   target="_blank"
                   rel="noopener noreferrer"
                   aria-label={data.title}
                   className="block transition hover:opacity-95"
                >
                    {image}
                </a>
            ) : (
                image
            )}
        </aside>
    );
}
